import { VEHICLE_STATUSES } from 'constants';
import { useViewedVehicle } from 'pages/Admin/ViewVehicle/hooks/useViewedVehicle';
import ReportOfSaleVersions from 'pages/Shared/VehicleDetails/ReportOfSaleVersions/ReportOfSaleVersions';
import { UnawardBlock } from './UnwardBlock';
import AwardBuyerBlock from './AwardBuyerBlock';

export const AwardControls = () => {
  const vehicle = useViewedVehicle();
  if (!vehicle) return null;

  if (vehicle.status === VEHICLE_STATUSES.DEACTIVATED || vehicle.status === VEHICLE_STATUSES.DRAFT) {
    return null;
  }

  if (vehicle.status === VEHICLE_STATUSES.AWARDED) {
    return (
      <>
        <UnawardBlock />
        <ReportOfSaleVersions vehicleId={vehicle.id} />
      </>
    );
  }

  return <AwardBuyerBlock />;
};
